import { BLUR_TOP_PERFORMERS } from '../../constant'
export default {
  setup() {
    return {
      topPerformers: BLUR_TOP_PERFORMERS
    }
  }
}
